import { render, staticRenderFns } from "./PianoKeyboard.vue?vue&type=template&id=bdfaadc6&"
import script from "./PianoKeyboard.vue?vue&type=script&lang=js&"
export * from "./PianoKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./PianoKeyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports